// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CbCJ6","col":"styles_col__2OLaG"};